<div class="modal-header bg-primary p-2">
  <div class="row w-100">
    <div class="col-10">
      <div class="d-flex align-items-center flex-wrap p-2 border-header">
        <div class="d-none d-lg-flex align-items-center">
          <app-image-color
            [height]="'30px'"
            [width]="'40px'"
            [url]="'menu-icons/sows.svg'"
            [color]="'#ffffff'"
          ></app-image-color>
        </div>
        <div class="line bg-white d-none d-lg-flex"></div>
        <div class="text-left ml-2">
          <div class="flex-column">
            <h2 class="mb-0 d-flex align-items-start">
              <h3 class="m-0">
                {{
                  harvestsStatus
                    ? ("clients.settings.harvest" | translate)
                    : ("clients.settings.pre-harvest" | translate)
                }}:
              </h3>
            </h2>
            <input
              [value]="textPonds(DataPonds)"
              placeholder="No hay estanques seleccionados"
              class="w-100"
              style="border: none; background-color: transparent; color: white"
              disabled
            />
          </div>
        </div>
      </div>
    </div>
    <div class="col-2 d-flex justify-content-end align-items-center" *ngIf="ButtonClosed">
      <h3 class="m-0 c-pointer" (click)="closedClick()">&times;</h3>
    </div>
  </div>
</div>
<div class="modal-body" style="margin-bottom: 30px">
  <div class="row">
    <div class="col-12">
      <form [formGroup]="harvestForm">
        <div class="row">
          <ng-container *ngIf="DataPonds.length === 1">
            <div class="col-6 p-2" id="kg_pond">
              <span>{{ "feed.pond-kg" | translate }}</span>
              <input
                formControlName="kg"
                [(ngModel)]="kgPond"
                (change)="calculateKgHA(DataPonds, 1)"
                type="text"
                class="form-control"
                placeholder="kg"
              />
            </div>
            <div class="col-6 p-2" id="kg_hec">
              <span>{{ "feed.hectare-kg" | translate }}</span
              ><br />
              <input
                [(ngModel)]="kgHec"
                (change)="calculateKgHA(DataPonds, 2)"
                [ngModelOptions]="{ standalone: true }"
                type="text"
                class="form-control"
                placeholder="kg"
              />
            </div>
            <div class="col-12">
              <small>{{ "feed.larva-amount" | translate }}.</small>
            </div>
          </ng-container>
          <ng-container *ngIf="DataPonds.length > 1">
            <div class="col-6 p-2" id="kg_pond">
              <span>{{ "feed.pond-kg" | translate }}</span>
              <input formControlName="kg" type="text" class="form-control" placeholder="kg" />
            </div>
            <div class="col-6 p-2" id="kg_hec">
              <span>{{ "feed.hectare-kg" | translate }}</span
              ><br />
              <b>{{ validatePonds(harvestForm.value.kg, DataPonds) }}</b>
            </div>
          </ng-container>
          <div class="col-12 p-2" id="date_sow">
            <span>{{ "tables.date" | translate }}</span
            ><br />
            <input type="date" formControlName="date" class="form-control" />
          </div>
          <div class="col-6 p-2" id="size_sow">
            <span>{{ "plantings.size" | translate }}</span
            ><br />
            <input formControlName="size" class="form-control" />
          </div>

          <div class="col-12 p-2">
            <div class="mb-2 d-flex justify-content-end">
              <button
                *ngIf="permissions.change_harvest"
                (click)="register()"
                class="btn btn-success"
                type="button"
                [disabled]="harvestForm.invalid || loading_petition"
                id="finish_sow"
              >
                <app-spinner
                  [smallLoader]="true"
                  [spinnerColor]="'text-white'"
                  *ngIf="loading_petition"
                >
                </app-spinner>
                <span class="m-0" *ngIf="!loading_petition">
                  {{ textButton ? textButton : ("general.send" | translate) }}
                </span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
